/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Material_DeletedInputs */

const vi_care_log_material_deleted = /** @type {(inputs: Care_Log_Material_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư đã xoá`)
};

/**

* @param {Care_Log_Material_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_material_deleted = /** @type {((inputs?: Care_Log_Material_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Material_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_material_deleted(inputs)
});